import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

export const useUserStore = defineStore('user', {
    state: () => ({
        username: useStorage('username', null),
        password: useStorage('password', null),
        token: useStorage('token', null),
        userId: useStorage('userId', null),
        workspaceId: useStorage('workspaceId', null),

    }),
    actions: {
        setUsername(username) {
            this.username = username
        },
        getUsername() {
            return this.username
        },
        setPassword(password) {
            this.password = password
        },
        getPassword() {
            return this.password
        },
        setToken(token) {
            this.token = token
        },
        getToken() {
            return this.token
        },
        setUserId(userId) {
            this.userId = userId
        },
        getUserId() {
            return this.userId
        },
        setWorkspaceId(workspaceId) {
            this.workspaceId = workspaceId
        },
        getWorkspaceId() {
            return this.workspaceId
        },
        clean() {
            this.username = null
            this.password = null
            this.token = null
            this.userId = null
            this.workspaceId = null
        }
    },
})